import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import FormBuilder from '../../../../common/form-builder/FormBuilder';
import { usePermission } from '../../../../../contexts/PermissionContext';
import FormField from '../../../../common/form-field/FormField';
import HelpIcon from '../../../../common/help-icon/HelpIcon';

export default function AISConfigForm(
  props: Readonly<{
    buId: string;
  }>
) {
  const { t } = useTranslation();
  const { findFeature } = usePermission();
  const { control } = useFormContext();

  const { buId } = props;
  const maxValueValidation = (e: any) => {
    return e.value <= 100;
  };

  const aisFormConfig = [
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'aisGapDuration',
      label: t('labels.aisGapDuration'),
      control: control,
      fieldType: 'number',
      id: 'aisGapDuration',
      isRequired: true,
      allowDecimal: false,
      helpText: t('toast.aisGapMinimumDurationDesc'),
      showHelpIcon: true,
      maxLength: 100,
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditAISGapConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditAISGapConfigurationSettings'),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'speedCalculationPercentage',
      label: t('labels.speedCalculationPercentage'),
      control: control,
      fieldType: 'number',
      id: 'speedCalculationPercentage',
      isRequired: true,
      showHelpIcon: true,
      helpText: t('toast.speedCalculationPercentageDesc'),
      maxLength: 3,
      disabled: buId
        ? !findFeature('BUCompanyConfiguration.EditAISGapConfigurationSettings')
        : !findFeature('CompanyConfiguration.EditAISGapConfigurationSettings'),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
        {
          type: 'custom',
          validationCallback: maxValueValidation,
          message: t('errors.maxHundred'),
        },
      ],
    },
  ];
  return (
    <div className="row">
      <FormBuilder formConfig={aisFormConfig} />
      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col ">
        <div className="mb-btm-space m-c-form-group">
          <label className=" m-l-input-label">
            {t('labels.aisGapRiskRatingLabel')}
            <HelpIcon
              id={'AISGapriskRating'}
              helpText={t('toast.aisGapRiskRatingTxt')}
            />
          </label>
        </div>
        <div className="check-box-ais-gap-risk-rating">
          <Controller
            name={'IsAISGapLowRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'low',
                  label: t('labels.low'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'low',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsAISGapMediumRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'medium',
                  label: t('Medium'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'medium',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsAISGapHighRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'high',
                  label: t('labels.high'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'high',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
